export default __webpack_public_path__ + "static/pierre-c83a9d65ffb44be6ffc88f447dfe00ad.jpg";